<template>
  <div class="nav">
    <div class="main_page">
      <h1>
        <a href="index.html"> <img src="../../assets/images/logo.png"/>融聚智慧 | 创造价值</a>
      </h1>
      <ul class="nav_menu">
        <li class=""><a href="javascript:;" @click="markConsultant('eadvice')">易咨询</a></li>
        <!--  <li><a href="Product_service.html">产品与服务</a></li>-->
        <li><a href="javascript:;">亿学堂</a></li>
        <li><a href="javascript:;">顾问家</a></li>
        <li class="last"><a href="javascript:;">企业俱乐部</a></li>
      </ul>
    </div>
  </div>
</template>
<script>
  import vhead from '../common/Head'
  import vservice from '../common/Service'
  export default {
    data: function () {
      return {
        info: {},
        allConsultantSize: "",
        allEntSize: ""
      }
    },
    methods: {
      markConsultant: function (val) {
        var self = this;

        var myMessage = userInfo.getMember();
        if (util.isVal(myMessage) != "") {
          self._data.info = myMessage;
        } else {
          self._data.info = "";
        }

        if (util.isVal(self._data.info.id) == "") {
          layer.msg("请先登陆！");
          window.location.href = "login.html";
        } else {
          if (val == "res") {
            window.location.href = "personalCenter.html#!/basicInfo";
          } else if (val == "ent") {
            window.location.href = "personalCenter.html#!/company_basicInfo";
          } else if (val == "eadvice") {
            window.location.href = "eadvice.html";
          }

        }
      }
    },
    components: {
      vhead,
      vservice
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// Header-nav.vue?0661980c